export default "__VITE_ASSET__03903af0__"